window.addEventListener("DOMContentLoaded", function() { 

    let logoImg = document.querySelector('#logoImg')

    window.addEventListener('resize', () => {
        setHeaderHeight()
        setModalsHeightMobile()
        // calculateLogoOverflow()
    })


    setHeaderHeight()
    // calculateLogoOverflow()

    if (logoImg) {
        logoImg.addEventListener('load', () => {
            setHeaderHeight()
        })
    }

    let logoName = document.querySelector('.headerLogoText')
    let logoIsHidden = false

    function hideLogo() {
        if(window.scrollY >= 20 && !logoIsHidden) {
            if(logoImg) { logoImg.classList.add('displayNone') }
            if(logoName) { logoName.classList.remove('displayNone') }
            setHeaderHeight()
            setModalsHeightMobile()
            logoIsHidden = true
        } else if(window.scrollY < 20 && logoIsHidden) {
            if(logoImg) { logoImg.classList.remove('displayNone') }
            if(logoName) { logoName.classList.add('displayNone') } 
            setHeaderHeight()
            setModalsHeightMobile()    
            logoIsHidden = false
        }

    }

    if(logoImg) {
        let shouldHide = logoImg.dataset.shouldHide == 'true' ? true : false 
        if(shouldHide) {
            window.addEventListener('scroll', hideLogo)
        }
    }

    window.addEventListener('shopify:section:unload', (e) => {
        if(e.detail.sectionId.includes('header')) {
            window.removeEventListener('scroll', hideLogo)
        }
    })

    window.addEventListener('shopify:section:load', (e) => {
        if(e.detail.sectionId.includes('header')) {
            logoImg = document.querySelector('#logoImg')
            logoName = document.querySelector('.headerLogoText')
            shouldHide = logoImg.dataset.shouldHide == 'true' ? true : false 
            if(!shouldHide) { return }
            window.addEventListener('scroll', hideLogo)
        }
    })

    function setHeaderHeight() {
        document.documentElement.style.setProperty('--headerHeight', document.querySelector('#headerBar').offsetHeight + 'px');
    } 


    function calculateLogoOverflow() {
        if(logoImg && logoImg.classList.contains('logoOverflow')) {
            let overflowHeight = logoImg.offsetHeight - parseInt(document.documentElement.style.getPropertyValue('--headerHeight'), 10) 
            document.documentElement.style.setProperty('--logoOverflowHeight', overflowHeight + 'px');
        }
    }

    function visibilityToggle(element) {

        if(window.innerWidth <= 800) {
            const filterWrap = document.querySelector('.filterModalWrapper')
            if(filterWrap) {
                filterWrap.classList.add('displayNone') 
                document.querySelector('#filterRelativeWrapper').dataset.visible = "false"                 
            }
        }


        let menu = element.querySelector('.menuWrapContent')

        const show = [
            { transform: 'translateX(-600px)' },
            { transform: 'translateX(0)' }
        ]
    
        const hide = [
            { transform: 'translateX(-600px)' }
        ]
    
        const options = {
            duration: 250,
            iterations: 1,
            fill: 'forwards'
        }
        
        if(element.classList.contains('displayNone')) {
            element.classList.remove('displayNone')
            menu.animate(show, options)
        } else {
            let anim = menu.animate(hide, options)
            anim.addEventListener('finish', () => {
                element.classList.add('displayNone')
            })
        }
        
    }

    function hideAllModals(elementId) {
        let menuModals = document.querySelectorAll('.menuWrap')
        menuModals.forEach(modal => {
            if(modal.id != elementId) {
                modal.classList.remove('slideInLeft')
                modal.classList.add('displayNone')
            }
        })
    }

    // Open and close menus ====================================
    let controlBtns = document.querySelectorAll('.controlBns')
    controlBtns.forEach(btn => {
        btn.addEventListener('click', handleMenuDisplay);
    })

    function handleMenuDisplay(e) {
        let el = e.target
        let elementId = el.dataset.controlElement
        hideAllModals(elementId)
        
        let element = document.getElementById(elementId)
        visibilityToggle(element);
    }

    // Open and close submenus ==================================== 
    let subMenuBtn = document.querySelectorAll('.subMenuBtn')
    subMenuBtn.forEach(btn => {
        btn.addEventListener('click', handleSubmenusDisplay);
    })


    function displayToggle(element) {
        if (!element.classList.contains('navSlideDown')) {
            element.classList.add('navSlideDown')
        } else {
            element.classList.remove('navSlideDown')
        }
    }

    function handleSubmenusDisplay(e) {
        let el = e.target
        let elementId = el.dataset.controlElement
        
        let element = document.getElementById(elementId)
        displayToggle(element);
    }

    // open close announcement bar 
    let annBar = document.querySelector('#annBar')
    if (annBar) {

        let annBarControlBtn = document.querySelector('.annBarControl')   

        if (annBarControlBtn) {
            annBarControlBtn.addEventListener('click', handleAnnBar)

            function handleAnnBar() {
                if (!annBar.classList.contains('slideOutRight')) {
                    annBar.classList.add('slideOutRight')
                    annBar.classList.remove('slideInRight')
                    annBarControlBtn.classList.add('flipY')
                    annBarControlBtn.classList.remove('resetFlipY')
                } else {
                    annBar.classList.add('slideInRight')
                    annBar.classList.remove('slideOutRight')
                    annBarControlBtn.classList.remove('flipY')
                    annBarControlBtn.classList.add('resetFlipY')
                }
            }
        }

    }


    let customCheckBoxes = document.querySelectorAll('.customCheckboxWrap');

    customCheckBoxes.forEach(checkbox => {
        if (checkbox.dataset.isChecked == "true") {
            checkbox.querySelector('.customCheckboxSvg').classList.remove('displayNone')
        }
        checkbox.addEventListener('click', handleCheckboxes)
    })

    function handleCheckboxes(e) {
        let checkboxWrap = e.currentTarget
        
        if(checkboxWrap.dataset.isDisabled){ e.stopImmediatePropagation(); return }
        
        let realcheckbox = checkboxWrap.querySelector('input')  
        checkboxWrap.querySelector('.customCheckboxSvg').classList.toggle('displayNone') 
        
        if (checkboxWrap.querySelector('.customCheckboxSvg').classList.contains('displayNone')) {
            if (realcheckbox) {realcheckbox.checked = false}
            checkboxWrap.dataset.isChecked = "false" 
        } else {
            if (realcheckbox) {realcheckbox.checked = true}
            checkboxWrap.dataset.isChecked = "true" 
        }
        
    }

    // Modals 

    function setModalsHeightMobile() {
        if(window.innerWidth <= 500) {
            document.documentElement.style.setProperty('--mobileWindowHeight', `${window.innerHeight}px`)
        }    
    }

    setModalsHeightMobile()

    let allModalsWraps = document.querySelectorAll('.modalWrap')


    let moalControlBtns = document.querySelectorAll('.modalControl')
    moalControlBtns.forEach(btn => {
        btn.addEventListener('click', modalDisplay)
    })


    function modalDisplay(e) {
        let modalId = e.currentTarget.dataset.controlElement
        allModalsWraps.forEach(wrap => {
            if(wrap.id != modalId) {
                wrap.classList.add('displayNone')
            }
        })

        let modal = document.getElementById(modalId)
        if(modal.classList.contains('displayNone')) {
            if (window.innerWidth <= 500) {
                document.documentElement.style.overflow = 'hidden'
            }
        } else {
            document.documentElement.style.overflow = 'auto'
        }
        modal.classList.toggle('displayNone')

        if(modalId == 'searchModal') {
            document.querySelector('#searchInp').focus()
        }   
    }

    // Cart ========================================
    const cartModal = document.querySelector('#cartModal')
    const cartIcon = document.querySelector('.cartIcon')

    if(cartIcon && cartModal.querySelector('.cartItemWrap')) {
        cartIcon.classList.add('cartHasElements')
    }


    let cartAccentBoxWrap = false
    let requestInProgress = false

    let lastKnownQuantity = 1
    let lastQuantityInput = null
    let lastQuantityValue = null

    initQuantityEvents()
    function initQuantityEvents() {
        let quantitySelectors = document.querySelectorAll('.cartQuantitySelectorInp')

        quantitySelectors.forEach(sel => sel.addEventListener('blur', updateQuantity))

        quantitySelectors.forEach( sel => sel.addEventListener('focus', (e) => {
            lastKnownQuantity = e.target.value
            lastQuantityInput = e.target
            lastQuantityValue = e.target.value
        }))

    };

    cartModal.addEventListener('click', updateItem)

    let updates = {
        'id': '',
        'quantity': 0
    }

    let note = document.querySelector('#cartNoteFaker')
    if (note) {
        let time
        note.addEventListener('keyup', () => {
            clearTimeout(time)
            time = setTimeout(() => {
                updateCartNote(note)                
            }, 300);
        })
    }

    function updateItem(e) {
        if(e.target.classList.contains('closeModalFloatyBtn')) {
            cartModal.classList.add('displayNone')
            document.documentElement.style.overflow = 'auto'
        }

        if((e.target.classList.contains('floatyBtn') || e.target.classList.contains('cartQuantityBtn')) && !e.target.classList.contains('closeModalFloatyBtn')) {
            if(requestInProgress) { return }
            showLoadingIcons('showLoading', e)
        }

        if(e.target.classList.contains('floatyBtn') && !e.target.classList.contains('closeModalFloatyBtn')) {
            // Delete item
            updates.id = e.target.closest('.cartItemWrap').dataset.itemKey
            updates.quantity = 0

            makeUpdateRequest(updates)
            deleteAnim(e)

        } else if (e.target.classList.contains('cartQuantityBtn')) {
            // Update quantity

            updates.id = e.target.closest('.cartItemWrap').dataset.itemKey

            if (e.target.dataset.quantityModify == "plus") {
                let input = e.target.previousElementSibling
                lastQuantityInput = input
                lastQuantityValue = input.value
                input.value ++
                updates.quantity = input.value
                makeUpdateRequest(updates)

            } else if (e.target.dataset.quantityModify == "minus") {
                let input = e.target.nextElementSibling 
                if(input.value > 1) {
                    lastQuantityInput = input
                    lastQuantityValue = input.value
                    input.value -- 
                    updates.quantity = input.value
                    makeUpdateRequest(updates)
                } else {
                    showLoadingIcons('endLoading')
                }
            }
        }

    }

    function updateQuantity(e) {
        if(e.target.value.trim() == '' || e.target.value.trim() == 0 ) {
            e.target.value = lastKnownQuantity
            return
        } 
        if(e.target.value == lastKnownQuantity) {
            return
        }
        if(requestInProgress) { return }
        if(e.target.value > 0) {            
            showLoadingIcons('showLoading', e)
            let cleanVal = Math.abs(Math.ceil(e.target.value))
            e.target.value = cleanVal 
            lastKnownQuantity = cleanVal
            updates.id = e.target.closest('.cartItemWrap').dataset.itemKey
            updates.quantity = cleanVal
            makeUpdateRequest(updates)
        } 

    }

    function updateCartNote(note) {
        fetch(`${window.Shopify.routes.root}cart/update.js`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({'note': `${note.value}`}) })
    }

    async function makeUpdateRequest(updates) {
        let sections = "cart"
        let data = {...updates, sections}

        let request =  await fetch(`${window.Shopify.routes.root}cart/change.js`, { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify(data) })  
        if (request.ok) {
            let res = await request.json()
            if(res.items.length == 0 && cartIcon) {
                cartIcon.classList.remove('cartHasElements')
            }

            let dom = new DOMParser().parseFromString(res.sections.cart, 'text/html')
            let currentCartItems = document.querySelectorAll('.cartItemWrap') 
            
            res.items.forEach((item, index) => {
                if(currentCartItems[index].dataset.itemKey == item.key) {
                    currentCartItems[index].querySelector('.cartQuantitySelectorInp').value = item.quantity 
                }
            })

            domUpdate(dom)
            initQuantityEvents()
            let itemsInCart = document.querySelector('.cartProductWrap')
            if(!itemsInCart) {
                let emptyCartPage = document.querySelector('.emptyCartPage')
                if(emptyCartPage) {
                    emptyCartPage.classList.remove('displayNone')
                }
            }
            showLoadingIcons('endLoading')
        } else {
            let errors = await request.json();
            window._popUpNotif(errors.description)
            showLoadingIcons('endLoading')
            lastQuantityInput.value = lastQuantityValue
        }

    }

    function showLoadingIcons(action, e = false) {
        if(action == 'showLoading') {
            requestInProgress = true
            cartAccentBoxWrap = e.target.closest('.cartItemWrap').querySelectorAll('.cartAccentBoxWrap');
            cartAccentBoxWrap[0].classList.toggle('displayNone')
            cartAccentBoxWrap[1].classList.toggle('displayNone')
            cartAccentBoxWrap[1].children[0].classList.remove('visibilityHide')
        } else if (action == 'endLoading') {
            cartAccentBoxWrap[0].classList.toggle('displayNone')
            cartAccentBoxWrap[1].classList.toggle('displayNone')
            cartAccentBoxWrap = false
            requestInProgress = false
        }

    }

    function deleteAnim(e) {
        let container = e.target.closest('.cartItemWrap')
        let cartPageParent = container.closest('.cartPageParent') 
        if(cartPageParent) {
            cartPageParent.remove()
            return
        }
        let anim = container.animate([{transform: "translateX(-500px)"}], {iterations: 1, duration: 250})
        anim.addEventListener('finish', () => {
            container.remove()
        })
    }

    function domUpdate(dom) {
        const itemCountSpan = dom.querySelector('.itemCountSpan')
        const checkoutForm = dom.querySelector('.liveCartFooter')
        const cartItems = dom.querySelectorAll('.cartItemWrap')

        const currentItems = document.querySelectorAll('.cartItemWrap')
        cartItems.forEach((itm, index) => {
            if(itm.dataset.itemKey == currentItems[index].dataset.itemKey) {
                currentItems[index].querySelector('.priceContainer').replaceWith(itm.querySelector('.priceContainer'))
            }
        })

        cartModal.querySelector('.modalMainContent').classList.remove('displayNone')            
        cartModal.querySelector('.itemCountSpan').innerText = itemCountSpan.innerText
        cartModal.querySelector('.liveCartFooter').innerHTML = ''
        if(itemCountSpan.innerText > 0) {
            cartModal.querySelector('.liveCartFooter').replaceWith(checkoutForm)
        } else {
            cartModal.querySelector('.liveCartFooter').classList.add('displayNone')
            cartModal.querySelector('.modalMainContent').classList.add('displayNone')    
            let cartPageCheckoutWrap = document.querySelector('.cartPageCheckoutWrap')     
            if (cartPageCheckoutWrap) {
                cartPageCheckoutWrap.classList.add('displayNone')
            }
        }
    }

    // search =============================================

    if(Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
            if (e.target.dataset.shopifyEditorSection.includes('search')) {
                initSearch()
            }
        })
    }

    initSearch()
    function initSearch() {
        const searchInp = document.querySelector('#searchInp')
        const searchDeb = debounce(search)
        searchInp.addEventListener('keyup', searchDeb)
        
    
        async function search(e) {
            if(e.key == 'Tab' || e.key == 'Shift') { return }
            showLoading('showLoading')
            let searchTerm = e.target.value
            let searchModal = document.querySelector('#searchModal')
            let currentModalContent = document.querySelector('#searchModal').querySelector('.modalMainContent'); 
            let currentModalFooter = document.querySelector('#searchModal').querySelector('.modalFooter')
            let currentSearchSuggestionsWrap = document.querySelector('.searchSuggestionsWrap')
            let searchModalOuterWrap = document.querySelector('.searchModalOuterWrap')
    

            if (searchTerm.trim().length == 0) {
                currentModalContent.innerHTML = ''
                currentModalContent.classList.add('displayNone')
                currentModalFooter.classList.add('displayNone')
                searchModalOuterWrap.style = 'grid-template-columns: 1fr';
                currentSearchSuggestionsWrap.classList.add('displayNone')
                searchModal.style = "";            
                showLoading('endLoading')
                return
            }
    
            let req = await fetch(`${window.Shopify.routes.root}search/suggest?q=${searchTerm}&section_id=search`)
            if(req.ok) {
                let resText = await req.text()
                let dom = new DOMParser().parseFromString(resText, 'text/html')  

                let modalMainContent = dom.querySelector('.modalMainContent') 
                let searchSuggestionsWrap = dom.querySelector('.searchSuggestionsWrap')

                if(searchSuggestionsWrap.children.length > 1) {
                    searchSuggestionsWrap.classList.remove('displayNone')
                    currentSearchSuggestionsWrap.replaceWith(searchSuggestionsWrap)
                    searchModal.style.maxWidth = '600px';
                    searchModalOuterWrap.style = 'grid-template-columns: 0.5fr 1fr';
                } else {
                    searchModalOuterWrap.style = 'grid-template-columns: 1fr';
                    searchSuggestionsWrap.classList.add('displayNone')
                    currentSearchSuggestionsWrap.replaceWith(searchSuggestionsWrap)
                    searchModal.style.maxWidth = '';
                }


                modalMainContent.classList.remove('displayNone')      
                if (dom.querySelector('.modalMainContent').children.length > 1) {
                    searchModal.style.display = "grid";
                    currentModalFooter.classList.remove('displayNone')
                    currentModalContent.replaceWith(dom.querySelector('.modalMainContent'))
                } else {
                    searchModal.style.display = "";
                    currentModalContent.replaceWith(dom.querySelector('.modalMainContent'))    
                    currentModalFooter.classList.add('displayNone')
                }
            }
            showLoading('endLoading')
        }
       
    
        const goToSearchPageBtn = document.querySelector('#goToSearchPageBtn')
        const goToSearchPageForm = document.querySelector('#goToSearchPageForm')
        
        goToSearchPageBtn.addEventListener('click', () => {goToSearchPageForm.submit()})    
    
        function debounce(func, timeout = 300) {
            let timer
            return (...args) => {
                clearTimeout(timer)
                timer = setTimeout(()=> {func.apply(this, args)}, timeout)
            }
        }
    
        let icons = document.querySelectorAll('.modalHeader .accentIcon')
        function showLoading(action) {
            if (action == 'showLoading') {
                icons[0].classList.add('displayNone')
                icons[1].classList.remove('displayNone')
            } else if (action == 'endLoading') {
                icons[0].classList.remove('displayNone')
                icons[1].classList.add('displayNone')
            }
        }
    
    }


    document.addEventListener('click', (e) => {
        if(!e.target.closest('.modalContentWrap') && !cartModal.classList.contains('displayNone') && !e.target.classList.contains('modalControl')) {
            if(!window.location.pathname.includes('cart')) {
                cartModal.classList.add('displayNone')
                document.documentElement.style.overflow = 'auto'
            }
        }
        if(!e.target.closest('.searchModalOuterWrap') && !searchModal.classList.contains('displayNone') && !e.target.classList.contains('modalControl')) {
            searchModal.classList.add('displayNone')
            document.documentElement.style.overflow = 'auto'
        }
    })


    // notification 
    let notTimeOut
    window._popUpNotif = function(message, time = 6000) {
        clearTimeout(notTimeOut)
        const notifContainer = document.querySelector('#notifContainer')
        const notifMessageContainer = document.querySelector('#notifMessage')
        notifMessageContainer.innerText = message
        notifContainer.classList.remove('displayNone')
        const show = [
            { marginTop: '-200px'},
            { marginTop: '0'},
        ]
    
        const options = {
            duration: 150,
            iterations: 1,
            fill: 'none'
        }

        let anim = notifContainer.animate(show, options)
        anim.addEventListener('finish', () => {
            notTimeOut = setTimeout(() => {
                notifContainer.classList.add('displayNone')                
            }, time);
        })
    }

});